// extracted by mini-css-extract-plugin
export default {"card":"JobInformation_card__mB4or","title":"JobInformation_title__lGj96","contents":"JobInformation_contents__U2-Nu"};